import { Box, Typography } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';
import { ProductRibbons } from '@/components/blocks/Ribbons';
import { ProductType } from '@/data/types/Product';
import { getImage } from '@/utils/getImage';
import { mergeRibbonsForProduct } from '@/utils/mergeRibbonsForProduct';
import { calculateProductPrices } from 'integration/utils/calculateProductPrices';
import { formatPrice } from 'integration/utils/formatPrice';
import {
	sponsoredProductSX,
	sponsoredProductImageSX,
	sponsoredProductInfoSX,
} from '@/components/blocks/DpCatalogEntrySearch/styles/container';
import {
	sponsoredProductTitleSX,
	sponsoredPricesSX,
	sponsoredPriceSX,
	sponsoredPriceOldSX,
} from '@/components/blocks/DpCatalogEntrySearch/styles/typography';

export const SponsoredProductCard = ({ product }: { product: ProductType }) => {
	const { price, priceWithoutOffer, shouldOffer } = calculateProductPrices({
		list: product.productPrice?.list ?? 0,
		offer: product.productPrice?.offer ?? 0,
		ribbons: product.ribbons ?? [],
	});

	const sortedRibbons = mergeRibbonsForProduct(product.ribbons ?? []);

	return (
		<Linkable href={product.seo?.href} sx={sponsoredProductSX} aria-label={product.name}>
			<Box sx={sponsoredProductImageSX}>
				<img src={getImage(product.thumbnail)} alt={product.name} />
				<ProductRibbons ribbons={sortedRibbons} />
			</Box>
			<Box sx={sponsoredProductInfoSX}>
				<Typography component="h3" sx={sponsoredProductTitleSX}>
					{product.name}
				</Typography>
				<Box sx={sponsoredPricesSX}>
					<Typography component="span" sx={sponsoredPriceSX}>
						{formatPrice(shouldOffer ? price : priceWithoutOffer, 'mxn')}
					</Typography>
					{shouldOffer ? (
						<Typography component="span" sx={sponsoredPriceOldSX}>
							{formatPrice(priceWithoutOffer, 'mxn')}
						</Typography>
					) : null}
				</Box>
			</Box>
		</Linkable>
	);
};
